/*
 * v8: the sale code (theme settings "Black Friday sale" + "v8 design") is applied for real through
 * Shopify's /discount/<code> link, so the bag and checkout charge the price the page shows.
 * Runs once per page; a visitor who already carries another code (e.g. a WELCOME code) keeps it.
 */
(function () {
  var DK = window.DK || {};
  var bf = DK.bf || {};
  if (!bf.live || !bf.auto || !bf.code) return;

  var code = String(bf.code).toUpperCase();
  var root = document.documentElement;

  function cookieCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]).toUpperCase(); } catch (e) { return m[1].toUpperCase(); }
  }

  function done(state) {
    root.classList.toggle('dk-bf-applied', state === 'applied');
    root.classList.toggle('dk-bf-other', state === 'other');
    DK.bf.state = state;
    document.dispatchEvent(new CustomEvent('dk:bf', { detail: { state: state } }));
  }

  function cart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function apply() {
    return fetch('/discount/' + encodeURIComponent(bf.code) + '?redirect=' + encodeURIComponent('/cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function () { done('applied'); }, function () { done('none'); });
  }

  var removed = false;
  try { removed = sessionStorage.getItem('dk_bf_removed') === '1'; } catch (e) {}
  var current = cookieCode();

  cart().then(function (c) {
    var codes = ((c && c.discount_codes) || [])
      .filter(function (d) { return d.applicable !== false; })
      .map(function (d) { return String(d.code).toUpperCase(); });
    if (codes.indexOf(code) > -1) return done('applied');
    if (codes.length) return done('other');
    // A shopper who took the code off in the bag keeps it off for this visit
    if (removed) return done('other');
    // Items in the bag: the bag script (developly-cart.js) puts the code on the cart itself
    if (c && c.item_count > 0) return done(current === code ? 'applied' : 'none');
    if (current === code) return done('applied');
    if (current) return done('other');
    return apply();
  });
})();
